import { type HTMLAttributes, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'
import { CircleInfoIcon } from '@/icons'
import { IconBadge } from '@/components/base/IconBadge'
import { Tag } from '@/components/base/Tag'
import { Tooltip } from '@/components/base/Tooltip'

export interface RetentionHeaderProps extends HTMLAttributes<HTMLDivElement> {
  icon: React.ReactNode
  accentColor?: 'none' | 'yellow' | 'green' | 'blue' | 'pink'
  tag?: string
  title: string
  tooltip?: string | React.ReactNode
  subtitle?: React.ReactNode
}

export const RetentionHeader = forwardRef<HTMLDivElement, RetentionHeaderProps>(
  ({ icon, accentColor = 'none', tag, title, tooltip, subtitle, className, ...props }, ref) => {
    return (
      <div className={twMerge('flex items-start gap-2 text-white', className)} ref={ref} {...props}>
        <div className="flex flex-col gap-1">
          <IconBadge accentColor={accentColor}>{icon}</IconBadge>
          {tag ? (
            <Tag
              accentColor={accentColor}
              className="justify-center uppercase font-formula font-bold [text-shadow:0px_1px_1px_rgba(0,0,0,0.25)]"
              size="sm"
            >
              {tag}
            </Tag>
          ) : null}
        </div>

        <div className="flex flex-col mt-1">
          <div className="flex items-center gap-2 text-2xl font-bold font-formula">
            <span>{title}</span>
            {tooltip ? (
              <Tooltip trigger={<CircleInfoIcon className="w-[18px] h-[18px]" />}>
                <div className="max-w-[160px] sm:max-w-[200px]">{tooltip}</div>
              </Tooltip>
            ) : null}
          </div>

          {subtitle ? <div className="text-md text-white/70">{subtitle}</div> : null}
        </div>
      </div>
    )
  }
)

RetentionHeader.displayName = 'RetentionHeader'
